module.exports = __webpack_public_path__ + "favicon-180x180.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/favicon-180x180.png
// module id = 1815
// module chunks = 0